<ion-footer class="sign-footer ion-no-border">
  <ion-item lines="none" menuClose class="footer" mode="md">
    <ion-label class="ion-no-margin ion-margin-top font-size--12px">Powered by UVE</ion-label>
  </ion-item>
</ion-footer>
